<!--
 * @Author: your name
 * @Date: 2020-08-24 14:48:46
 * @LastEditTime: 2020-09-04 09:33:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \jiachi\src\App.vue
-->
<template>
<div id="app">
    <navigator />
    <router-view />
    <foot />
    <el-dialog :visible.sync="show" width="700px" title="产品搜索" center>
        <div class="select-box">
            <i class="el-icon-search"></i>
            <el-select v-model="value" class="select" filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod" :loading="loading" @change="select">
                <el-option v-for="(item,index) in options" :key="item.id" :label="item.name" :value="index"></el-option>
            </el-select>
        </div>
    </el-dialog>
</div>
</template>

<script>
import navigator from "./components/navigation";
import foot from "./components/foot";
import {
    productList
} from "./assets/js/api";
export default {
    components: {
        navigator,
        foot,
    },
    data() {
        return {
            show: false,
            value: "",
            loading: false,
            options: [],
        };
    },
    methods: {
        select(e) {
            this.show = false;
            this.$router.push({
                path: "/product/detail",
                query: {
                    id: this.options[e].id,
                    idx: this.options[e].classe_id,
                },
            });
            setTimeout(() => {
                this.options = [];
                this.value = "";

            }, 100);
        },
        remoteMethod(e) {
            console.log(e);
            this.loading = true;
            productList({
                    limit: 9999,
                    page: 1,
                    where: {
                        name: e,
                    },
                })
                .then((r) => {
                    this.loading = false;
                    this.options = r.data.data;
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="less">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.select-box {
    margin: 50px 0;
    position: relative;

    i {
        font-size: 25px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 20px;
    }

    /deep/.el-input__inner {
        background: rgb(236, 236, 236);
    }
}

.select {
    width: 650px;
    margin: 0 auto;
}

html,
body {
    padding: 0;
    margin: 0;
}

html {
    min-width: 1200px;
    overflow-x: auto;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
ul {
    list-style: none;
    margin: 0;
}

.show-more-btn {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(154, 154, 154, 1);
    cursor: pointer;
    user-select: none;

    img {
        width: 49.5px;
        margin-right: 10px;
        height: 49.5px;
    }
}

.show-more-btn:active {
    opacity: 0.78;
}

.rich {
    word-break: break-all;
    padding: 20px;
    box-sizing: border-box;

    img {
        max-width: 100%;
    }
}

.el-pagination {
    text-align: center;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #0e6cb6 !important;
}
</style>
